import { IUser } from '@apps/Users/@services/users.service';
import { round } from '@helpers/mathHelper';

import { mapHikingTimezoneItem } from './hikingTimezones.mapper';
import {
  IHikingBaeWithTypeDTO,
  IHikingBaseDTO,
  IHikingMemberAllergyDTO,
  IHikingTypeDTO,
} from '../@types/DTO/hiking.dto.types';
import { IHikerDTO, IHikerPositionDTO, IHikingDataDTO } from '../@types/hiking.backTypes';
import {
  IHiker,
  IHikerPosition,
  IHikingData,
  IHikingMemberAllergy,
  IHikingType,
} from '../@types/hiking.types';
import { IBaseHiking, IBaseHikingWithType } from '../@types/hikingList.types';
const mapPositionToFront = (backData: IHikerPositionDTO): IHikerPosition => {
  return {
    id: +backData.id_position,
    name: backData.name,
    description: backData.description,
    comment: backData.comment,
    date: new Date(backData.date),
    approve_date: new Date(backData.approve_date),
    approver: backData.approver,
  };
};

const mapHikersToFront = (backData: IHikerDTO): IHiker => {
  return {
    idUser: +backData.id_user,
    date: new Date(+backData.date * 1000),
    dateFrom: backData.date_from ? new Date(backData.date_from) : null,
    dateTo: backData.date_to ? new Date(backData.date_to) : null,
    name: backData.name,
    surname: backData.surname,
    photo: {
      50: backData.photo_50,
      100: backData.photo_100,
    },
    isGirl: backData.sex !== '1',
    positions: backData?.positions?.map(mapPositionToFront) ?? [],
    inaturalist_login: backData.inaturalist_login,
  };
};

export const mapHikingDataToFront = (backData: IHikingDataDTO): IHikingData => {
  const d1 = new Date(backData.start);
  const d2 = new Date(backData.finish);
  return {
    id: +backData.id,
    name: backData.name,
    desc: backData.desc,
    slogan: backData.slogan || null,

    allow_join_before: backData.allow_join_before ? new Date(backData.allow_join_before) : null,
    members_limit: +backData.members_limit,

    start: d1,
    finish: d2,
    duration: round((d2.getTime() - d1.getTime()) / 86400000),

    type: {
      id: +backData.id_type,
      name: backData.type,
    },

    region: {
      id: +backData.id_region,
      name: backData.region_name,
    },

    route: {
      id: +backData.id_route,
      isVacant: +backData.is_vacant_route === 1,
    },

    visual: {
      bg: backData.bg,
      color: backData.color,
      photo: backData.photo,
    },

    hikers: backData.hikers.map(mapHikersToFront),
    timezones: backData.timezones.map(mapHikingTimezoneItem),
  };
};

export const mapHikerToUser = (hiker: IHiker): IUser => {
  return {
    id: hiker.idUser,
    name: hiker.name,
    surname: hiker.surname,
    photo: hiker.photo['50'] ?? hiker.photo['100'],
  };
};

export const mapUserToHiker = (user: IUser): IHiker => {
  return {
    idUser: user.id,
    name: user.name,
    surname: user.surname,
    photo: {
      50: user.photo,
      100: user.photo,
    },
    date: new Date(),
    dateFrom: null,
    dateTo: null,
    isGirl: false,
    positions: [],
    inaturalist_login: null,
  };
};

export const mapHikingTypeToFront = (backData: IHikingTypeDTO): IHikingType => {
  return {
    id: +backData.id,
    name: backData.name,
  };
};

export const mapHikingBaeWithTypeToFront = (
  backData: IHikingBaeWithTypeDTO,
): IBaseHikingWithType => {
  return {
    id: +backData.id,
    name: backData.name,
    ava: backData.ava,
    start: new Date(backData.start),
    finish: new Date(backData.finish),
    type: {
      id: +backData.id_type,
      name: backData.type,
    },
  };
};

export const mapHikingMemberAllergy = (backData: IHikingMemberAllergyDTO): IHikingMemberAllergy => {
  return {
    id: +backData.id,
    name: backData.name,
    comment: backData.comment,
    id_product: backData.id_product ? +backData.id_product : null,
    id_medicament: backData.id_medicament ? +backData.id_medicament : null,
    created_at: new Date(backData.created_at),
    updated_at: backData.updated_at ? new Date(backData.updated_at) : null,
    user: {
      id: +backData.id_user,
      name: backData.user_name,
      surname: backData.user_surname,
      photo: backData.user_photo,
    },
  };
};

export const getBaseHikingFromHikingData = (hikingData: IHikingData): IBaseHiking => {
  return {
    id: hikingData.id,
    name: hikingData.name,
    ava: hikingData.visual.photo,
    start: hikingData.start,
    finish: hikingData.finish,
  };
};

export const mapBaseHikingToFront = (hikingData: IHikingBaseDTO): IBaseHiking => {
  return {
    id: +hikingData.hiking_id,
    name: hikingData.hiking_name,
    ava: hikingData.hiking_ava,
    start: new Date(hikingData.hiking_start),
    finish: new Date(hikingData.hiking_finish),
  };
};
